import React from 'react';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import DatePicker from 'views/Users/Details/UserDetails/dialogs/subcomponents/DatePicker';
import { BodyS } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISelectAccessProps {
	isUnlimited: boolean;
	date: string;
	setDate: (date: string) => void;
	error?: boolean;
}

const SelectAccess = ({ isUnlimited, date, setDate, error }: ISelectAccessProps) => {
	const classes = useStyles();
	return (
		<div className={classes.selectAccessContainer}>
			<BodyS disableMargin>{translate('select.expiration.date')}</BodyS>
			<div className={classes.accountDatePicker}>
				<DatePicker
					isUnlimited={isUnlimited}
					date={date}
					setDate={setDate}
					error={error}
					label={translate('date')}
				/>
			</div>
		</div>
	);
};

export default SelectAccess;
